export default {"src":"/_next/static/media/contract-success.45fdf601.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};